import type { FolderShape } from "#internal"
import type { FolderPath } from "#public"

/** Cuts inside a die, adding nothing to its outline. */
export const FolderCuts = (...cut: FolderPath[]): FolderShape => ({
  corners: [],
  cut,
  fold: [],
})
